export function getMaxBase10Number(base36Characters) {
    return Math.pow(36, base36Characters) - 1;
}
export function mapBase10ToBase36(valueBase10) {
    return (valueBase10 % 36).toString(36);
}
